// extracted by mini-css-extract-plugin
module.exports = {"loader":"I","smallLoader":"J","loading-keyframes":"K","pageLoader":"L","centered":"M","whitespacePlaceholder":"N","buttonSpinner":"O","fade-in":"P","rotate":"Q"};